import { createFileRoute } from '@tanstack/react-router';
import { PreferencesClient } from '@/features/notifications/PreferencesClient';

export const Route = createFileRoute('/_shell/preferences')({
  component: PreferencesClient,
});
